import { render, staticRenderFns } from "./ModalProcesso.vue?vue&type=template&id=cb41b3c6&scoped=true&"
import script from "./ModalProcesso.vue?vue&type=script&lang=js&"
export * from "./ModalProcesso.vue?vue&type=script&lang=js&"
import style0 from "./ModalProcesso.vue?vue&type=style&index=0&id=cb41b3c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb41b3c6",
  null
  
)

export default component.exports